// client_javascript/src/index.js
/* globals */
import { logWithOffset } from "./logWithOffset";
import $ from './jquery.slim.min.js';
import ApiClient         from './api_client';
import populateFields    from './populate_fields';
import setupCheckoutForm from './checkout_form';
import {loadStripe}      from '@stripe/stripe-js';
import testMode          from './test_mode';
import {distance }       from 'fastest-levenshtein';
import LocalCart         from '../../stacks/lambda/local-cart';
import { setupEvents, fireEvent } from './events';
import KlarnaLocal from "./klarna";
import { AfterpayLocal } from "./afterpay";
import { applySplitTesting } from "./split_test";
import { addHandlerBySelector, addClassBySelector, removeClassBySelector, setValBySelector, setHtmlBySelector, selectorPresent, getMeta } from './utils.js';
import { triggerCheckoutFailedEvent } from "./triggerCheckoutFailedEvent";
import { setupTimers } from "./timers";
import { digestMessage } from "./digestMessage";
import { cartHtml as cartHtmlDefault }    from './components/cart';
import { addressHtml } from './components/address';
import { RTC } from "./rtc";
import { urlToAbsolute } from './urlToAbsolute';
import i18next from 'i18next';
import { setupTranslations} from "./translate";


window.rtcDrawCartFn = window.rtcDrawCartFn || cartHtmlDefault;

class Checkout {

  constructor() {
    logWithOffset("Initializing.....");
    this.load_settings();
    if (typeof(this.settings.recoveryCartId) === 'string') {
      let newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("recoveryCartId");
      window.history.pushState({}, '', newUrl.href);
    }
    this.jQuery = $;
    this.apiClient = new ApiClient(this.settings);
    this.cart = null;
    this.settings.sessionId = this.apiClient.sessionId;
    this.splitDecisions = applySplitTesting(this.settings.sessionId);
    this.settings.splitDecisions = JSON.stringify(this.splitDecisions);
    this.lineItemHtmlFn = null;
    this.nextUrlFn = null;
    // Legacy, Miracle only.
    if (this.settings.nextUrl && this.settings.nextUrl.indexOf("{sessionId}") > -1 ) {
      this.settings.nextUrl = this.settings.nextUrl.replace("{sessionId}", this.apiClient.sessionId);
    }


    this.isReceipt = this.settings.isReceiptPage || ($('.checkout-billing-address').length > 0) || ($('.checkout-shipping-address').length > 0);
    this.settings.estimateTax = this.isReceipt;

    this.currencyFormatterCallback = this.currencyFormatterCallback || ((value) => {
      return value;
    });
    this.firedPixels = [];
    this.pixelListeners = [];
    this.ccLock = false;
    this.stripeLock = false;
    // One-shot flag: true only for the single synchronous re-entry into
    // spreedlyCreditCardFormHandler that a just-completed tokenization triggers on its own.
    this._spreedlyHandoff = false;
    this.ready = false;
    this.setupGlobals();
  }

  async resetSession() {
    this.apiClient.newSession();
    this.loadCart();
  }

  setCurrencyFormatterCallback(newCallback) {
    this.currencyFormatterCallback = newCallback.bind(this);
    this.drawCart();
  }

  fillAddresses() {
    return {
      email: this.cart.fillEmail,
      shippingAddress: this.cart.fillShippingAddress,
      billingAddress: this.cart.fillBillingAddress
    }
  }

  getVariantData(variantId) {
    const data = Object.assign({}, this.pricingData[variantId], this.pricingData[variantId].presentmentPrices[this.cart.cartCurrency]);
    delete data.presentmentPrices;

    data.shippingRate = 0;
    data.shippingRateFormatted = "";


    try {
      if (data.shippingRates[this.cart.shippingZone]) {
        data.shippingRate = data.shippingRates[this.cart.shippingZone];
      } else {
        data.shippingRate = data.shippingRates["DEFAULT"] || 0;
      }

      data.shippingRateFormatted = this.currencyFormatter(data.shippingRate);
    } catch (err) {
      console.log(err);
    }

    delete data.shippingRates;

    ["price", "compareAtPrice", "compareSavings"].forEach(field => {
      const num = parseFloat(data[field]);
      if (num && !isNaN(num)) {
        data[field + "Formatted"] = this.currencyFormatter(num);
      }
    });
    return data;
  }

  eventsCommon() {
      const e = {
        ip: this.settings.ipAddress,
        userAgent: this.settings.userAgent,
        sessionCartId: this.settings.sessionId,
        advertorialPageName: this.cart.advertorialPageName,
        landingPageName: this.cart.landingPageName,
        auxPageName: this.cart.auxPageName,
        funnelName: this.cart.funnelName,
        pageParams: this.cart.checkoutPageParams,
        country: this.cart.shippingZone,
        primaryVariantId: this.cart.primaryVariantId,
        splitDecisions: this.splitDecisions,
        locale: this.cart.locale,
        parentSessionCartId: this.cart.parentSessionCartId,
        facebookPixelId: this.cart.facebookPixelId,
        checkoutPageName: this.cart.checkoutPageName,
        primaryVariantTitle: "",
        primaryVariantPrice: "",
        primaryVariantComparePrice: "",
        primaryVariantImage: ""
      }

      if (e.primaryVariantId && e.primaryVariantId.length) {
        for (const li of this.cart.localCart.lineItems) {
          if (String(li.variantId) === String(e.primaryVariantId)) {
            const vd = this.getVariantData(String(e.primaryVariantId));
            e.primaryVariantTitle = vd.variantTitle;
            e.primaryVariantPrice = li.price;
            e.primaryVariantComparePrice = li.compareAtPrice;
            e.primaryVariantImage = vd.image;
          }
        }
      }

      return e;

  }

  setupGlobals() {
    window.checkout = this;
    window.checkoutData = this.settings;
    window.checkoutData.cart = {};
    window.checkoutReadyCallbacks = window.checkoutReadyCallbacks || [];
    window.checkoutReadyCallbacks.push(async () => { this.fireCheckoutUpdateCallbacks(); });
    window.checkoutReadyCallbacks.push(async () => { logWithOffset('Initialization Complete'); });
    window.apiClient = this.apiClient;
    window.checkoutUpdateCallbacks = window.checkoutUpdateCallbacks || [];
  }


  async setupCouponField() {
    $(document).on("click", ".checkout-coupon-button", async () => {
      const value = $('.checkout-coupon-field').val();
      const newCart = await this.apiClient.applyCoupon(value.trim());
      this.setCart(newCart);
    });

    $(document).on("click", ".checkout-remove-coupon", async () => {
      const newCart = await this.apiClient.removeCoupon();
      this.setCart(newCart);
    });

    $(document).on("keypress", ".checkout-coupon-field", async (e) => {
      if (e.which === 13) {
        const value = $('.checkout-coupon-field').val();
        const newCart = await this.apiClient.applyCoupon(value.trim());
        this.setCart(newCart);
      }
    });



  }

  currentShippingZone() {
    return this.cart.shippingZone;
  }

  currentCouponCode() {
    return this.cart.couponCode;
  }


  async setupReceiptPage() {
    if (this.isReceipt) {
      setHtmlBySelector('.checkout-billing-address', addressHtml(this.cart.billingAddress));
      setHtmlBySelector('.checkout-shipping-address', addressHtml(this.cart.shippingAddress));
    }
  }

  async addPixel(callback) {
    //console.log("Adding Pixel ");
    callback = callback.bind(this);
    this.pixelListeners.push(callback);

    for (let i = 0; i < this.firedPixels.length; i++) {
      await callback(this.firedPixels[i]);
    }
  }

  async firePixel(e) {
    //console.log(JSON.stringify(e, null, 4));
    this.firedPixels.push(e);
    await fireEvent(e);
    for (let i = 0; i < this.pixelListeners.length; i++) {
      let listener = this.pixelListeners[i];
      try {
        await listener(e);
      } catch(err) {
        console.log("Failed to fire Pixel");
        console.log(err);
      }
    }
  }

  async firePixels() {
    const res = await this.apiClient.getBrowserEvents();
    if ("events" in res) {
      for (let i = 0; i < res.events.length; i++) {
        await this.firePixel(Object.assign({}, res.events[i], { no_server: true }));
      }
    }
  }

  async initBraintree() {
    if (document.getElementById('braintree-cc-number') === null) {
      return;
    }

    const ccField  = document.getElementById('braintree-cc-number');
    const expField = document.getElementById('braintree-expiry');
    const cvvField = document.getElementById('braintree-cvv');

    const now = new Date();
    const year = `${now.getUTCFullYear()}`;


    let ccPlaceholder = "1111 1111 1111 1111";
    let cvvPlaceholder = "123";
    let expPlaceholder = `12/${year.substr(2,2)}`;


    if (ccField) {
      ccPlaceholder = ccField.dataset.placeholder || ccPlaceholder;
    }
    if (expField) {
      expPlaceholder = expField.dataset.placeholder || expPlaceholder;
    }

    if (cvvField) {
      cvvPlaceholder = cvvField.dataset.placeholder || cvvPlaceholder;
    }

    // The real, interactive Braintree iframes don't exist in these divs yet -
    // they only get injected once client.min.js + hosted-fields.min.js load
    // over the network and hostedFields.create() confirms success. Until then
    // a shopper can see fully-styled empty fields and tap them with nothing
    // happening (reported worst on slower connections / iOS FB-IG in-app
    // browsers). Mirrors Braintree's own documented integration pattern:
    // disable submission and mark the fields as not-yet-interactive until
    // create() actually confirms ready.
    const pendingFields = [ccField, expField, cvvField].filter(Boolean);
    const submitForm = ccField.closest('form');
    const submitButtons = submitForm
      ? Array.from(submitForm.querySelectorAll('.checkout-submit-combo, .checkout-submit-credit-card'))
      : [];

    pendingFields.forEach(f => {
      f.classList.add('checkout-braintree-pending');
      f.style.pointerEvents = 'none';
      f.style.opacity = '0.5';
    });
    submitButtons.forEach(b => { b.disabled = true; });

    const markBraintreeFieldsSettled = () => {
      pendingFields.forEach(f => {
        f.classList.remove('checkout-braintree-pending');
        f.style.pointerEvents = '';
        f.style.opacity = '';
      });
      submitButtons.forEach(b => { b.disabled = false; });
    };


    this.braintreeToken = await this.apiClient.initBraintree();
    const head      = document.getElementsByTagName('head')[0];
    const script1   = document.createElement("script");
    const script2   = document.createElement("script");
    script1.src = "https://js.braintreegateway.com/web/3.44.2/js/client.min.js";
    script2.src = "https://js.braintreegateway.com/web/3.44.2/js/hosted-fields.min.js";
    script1.async = false;
    script2.async = false;
    script2.onload = () => {
      window.braintree.hostedFields.create({
        authorization: this.braintreeToken.clientToken,
        styles: {
          'input': {
            'color': '#3A3A3A'
          },
          '.number': {
            'font-family': 'monospace'
          },
          '.valid': {
            'color': 'green'
          },
          '.invalid': {
            'color': 'red'
          }
        },
        fields: {
          number: {
            selector: '#braintree-cc-number',
            placeholder: ccPlaceholder,
          },
          cvv: {
            selector: '#braintree-cvv',
            placeholder: cvvPlaceholder,
          },
          expirationDate: {
            selector: '#braintree-expiry',
            placeholder: expPlaceholder
          }
        }
      }, (hostedFieldsErr, hostedFieldsInstance) => {
        if (hostedFieldsErr) {
          console.log(hostedFieldsErr);
          // Don't leave checkout permanently blocked on an init failure - the
          // existing tokenize-time error handling (missingCreditCardFields)
          // still applies if the shopper tries to pay.
          markBraintreeFieldsSettled();
          return;
        } else {
          this.braintreeHostedFieldsInstance = hostedFieldsInstance;
          markBraintreeFieldsSettled();
        }
      });

    }
    head.appendChild(script1);
    head.appendChild(script2);
    logWithOffset("Braintree initialized");

  }
    
  // Converts a camelCase style object (fontSize, color, padding, fontFamily, ...) into
  // the raw CSS text string Spreedly's setStyle() expects.
  buildSpreedlyStyleString(styleObj) {
    return Object.entries(styleObj)
      .map(([prop, value]) => `${prop.replace(/[A-Z]/g, m => '-' + m.toLowerCase())}: ${value};`)
      .join(' ');
  }

  // Applies a field's configured base style, optionally overriding just the color
  // (used for the live valid/invalid coloring) without dropping fontSize/padding/fontFamily.
  applySpreedlyFieldStyle(field, colorOverride) {
    const style = { ...(this.spreedlyBaseStyles[field] || {}) };
    if (colorOverride) {
      style.color = colorOverride;
    }
    this.spreedly.setStyle(field, this.buildSpreedlyStyleString(style));
  }

  // Decides the color for one field from its cached state: green the moment it's valid,
  // red only once the shopper has left it at least once — so a half-typed card number
  // isn't marked wrong on every keystroke. Empty fields stay neutral; submit-time
  // validation is what enforces "required".
  paintSpreedlyField(field) {
    const state = this.spreedlyFieldState[field];
    let color = null;

    if (state.length > 0 && state.valid) {
      color = this.spreedlyValidationColors.valid;
    } else if (state.length > 0 && state.touched) {
      color = this.spreedlyValidationColors.invalid;
    }

    // setStyle is a cross-origin postMessage; skip it when nothing actually changed.
    if (state.color === color) return;
    state.color = color;
    this.applySpreedlyFieldStyle(field, color);
  }

  async initSpreedly() {
    if (document.getElementById('spreedly-number') === null) {
      return;
    }

    logWithOffset("Spreedly detected. Initializing...");

    if (!window.SpreedlyPaymentFrame) {
      const script = document.createElement('script');
      script.src = "https://core.spreedly.com/iframe/iframe-v1.min.js";
      script.async = false;
      document.head.appendChild(script);

      await new Promise(resolve => { script.onload = resolve; });
    }

    this.spreedly = new SpreedlyPaymentFrame();
    const publicKey = this.settings.spreedlyPublicKey;

    if (!publicKey) {
      console.error("Spreedly public key is missing. Add meta[name='checkout-spreedly-public-key']");
      return;
    }

    this.spreedly.init(publicKey, {
      numberEl: 'spreedly-number',
      cvvEl: 'spreedly-cvv'
    });

    // Read configuration from window.SPREEDLY_CONFIG if provided by embedding site.
    // Set before 'ready' fires (not inside its callback) so a validity event
    // can never race ahead of these being defined and throw on an undefined lookup.
    const config = window.SPREEDLY_CONFIG || {};
    this.spreedlyBaseStyles = config.styles || {};
    this.spreedlyValidationColors = config.validationColors || { valid: '#2e7d32', invalid: '#c62828' };

    // Cached validity per iframe field. Needed because 'blur' arrives with an empty
    // inputProperties, so the decision to paint red has to use the last 'input' we saw.
    // touched = the shopper has left the field at least once; color = what's currently applied.
    this.spreedlyFieldState = {
      number: { length: 0, valid: false, touched: false, color: null },
      cvv:    { length: 0, valid: false, touched: false, color: null }
    };

    this.spreedly.on('ready', () => {
      // Placeholders: use config if provided, fall back to defaults
      const placeholders = config.placeholders || {
        number: '**** **** **** ****',
        cvv: '123'
      };
      Object.entries(placeholders).forEach(([field, placeholder]) => {
        this.spreedly.setPlaceholder(field, placeholder);
      });

      // Styles: apply if provided in config (camelCase JS object -> CSS text for setStyle)
      Object.keys(this.spreedlyBaseStyles).forEach((field) => {
        this.applySpreedlyFieldStyle(field);
      });

      // Labels: apply if provided in config
      if (config.labels) {
        Object.entries(config.labels).forEach(([field, label]) => {
          this.spreedly.setLabel(field, label);
        });
      }

      // Number format: apply if provided in config
      if (config.numberFormat) {
        this.spreedly.setNumberFormat(config.numberFormat);
      }

      // Field types: apply if provided in config
      if (config.fieldTypes) {
        Object.entries(config.fieldTypes).forEach(([field, type]) => {
          this.spreedly.setFieldType(field, type);
        });
      }

      logWithOffset("Spreedly iFrame ready");
    });

    this.spreedly.on('paymentMethod', (token, pmData) => {   // Note: keep the second param for future-proofing
    console.log('Spreedly token received:', token);

    const form = document.querySelector('.checkout-combo-form');
    if (!form) return;

    let tokenField = form.querySelector('input[name="spreedlyToken"]');
    if (!tokenField) {
        tokenField = document.createElement('input');
        tokenField.type = 'hidden';
        tokenField.name = 'spreedlyToken';
        form.appendChild(tokenField);
    }
    tokenField.value = token;

    this.ccLock = false;

    // Mark this one synchronous re-entry as authorized before triggering it: the very next
    // call into spreedlyCreditCardFormHandler is THIS tokenization's own continuation, not a
    // fresh click. Consumed (and cleared) the instant that continuation runs, so it can never
    // cover a later, genuine re-click that happens to find the same token still on the form.
    this._spreedlyHandoff = true;

    // Instead of form.submit(), manually trigger the handler again
    // This re-uses your existing logic safely
    console.log('Spreedly token set — manually proceeding to charge');
    this.spreedlyCreditCardFormHandler({ currentTarget: form });   // Fake the event object
    });

    this.spreedly.on('errors', (errors) => {
      console.error('Spreedly errors:', errors);
      this.ccLock = false;
      triggerCheckoutFailedEvent();
    });

    // Live valid/invalid coloring. Spreedly has no top-level 'input' event — everything arrives
    // through 'fieldEvent' as (name, type, activeEl, inputProperties), where name is 'number'
    // or 'cvv' and only type === 'input' carries inputProperties (blur/focus/tab pass {}).
    this.spreedly.on('fieldEvent', (name, type, activeEl, inputProperties) => {
      // Every input event reports the current state of BOTH fields, so refresh both —
      // that also keeps autofill correct, where one event can populate number and cvv at once.
      if (type === 'input' && inputProperties) {
        Object.assign(this.spreedlyFieldState.number, {
          length: inputProperties.numberLength,
          valid: inputProperties.validNumber
        });
        Object.assign(this.spreedlyFieldState.cvv, {
          length: inputProperties.cvvLength,
          valid: inputProperties.validCvv
        });
        this.paintSpreedlyField('number');
        this.paintSpreedlyField('cvv');
        return;
      }

      // Leaving a field is what unlocks the red state for it.
      if (type === 'blur' && this.spreedlyFieldState[name]) {
        this.spreedlyFieldState[name].touched = true;
        this.paintSpreedlyField(name);
      }
    });

    // Make instance available for tokenization trigger
    window.spreedlyInstance = this.spreedly;
  }    

  async initStripeCommon() {
    this.stripe         = this.stripe         || await loadStripe(this.settings.stripePublicKey);
    this.stripeElements = this.stripeElements || this.stripe.elements();
  }

  async initStripe() {
    if (document.getElementById('stripe-cc-number') === null) {
      return;
    }
    await this.initStripeCommon();
    this.cardNumberElement = this.stripeElements.create('cardNumber', { showIcon: true });
    this.cardNumberElement.mount('#stripe-cc-number');
    this.cardExpElement = this.stripeElements.create('cardExpiry');
    this.cardExpElement.mount('#stripe-exp');
    this.cardCvvElement = this.stripeElements.create('cardCvc');
    this.cardCvvElement.mount('#stripe-cvv');
    logWithOffset("Stripe Initialized");
  }

  async completeStripeWallet(paymentInfo, stripeResult) {
    console.log('completeStripeWallet');
    console.log(paymentInfo);

    const shipAddr = paymentInfo.shippingAddress;
    let nameArr = shipAddr.recipient.split(" ");
    let fname = nameArr.shift();
    let lname = nameArr.join(" ");

    if (lname && lname.trim) {
      lname = lname.trim();
    }

    if (fname && fname.trim) {
      fname = fname.trim();
    }

    if (fname === "") {
      fname = "Unknown";
    }

    if (lname === "") {
      lname = "Unknown"
    }

    const chargeData = {
      shipping: {
        first_name:    fname,
        last_name:     lname,
        address1:      shipAddr.addressLine[0],
        address2:      shipAddr.addressLine[1] || "",
        city:          shipAddr.city,
        state:         shipAddr.region,
        postal_code:   shipAddr.postalCode,
        country:       shipAddr.country,
        phone:         shipAddr.phone
      }
    };

    chargeData.billing = chargeData.shipping;
    chargeData.stripe_intent = stripeResult.paymentIntent;
    chargeData.email = paymentInfo.payerEmail;

    let chargeResult = null;
    try {
      chargeResult = await this.apiClient.charge(chargeData);
    } catch(err) {
      alert(i18next.t("cart.genericProcessingError"));
      triggerCheckoutFailedEvent();
      return;
    }
    if (!chargeResult || "error" in chargeResult) {
      alert(chargeResult.error);
      triggerCheckoutFailedEvent();
    } else {
      window.location = this.getNextUrl();
    }
  }

  async initStripeBancontact() {
    //stripe-ideal
    if (document.getElementById('checkout-bancontact-container') === null) {
      return;
    }

    logWithOffset("Initializing Stripe bancontact");
    await this.initStripeCommon();

  }

  async bancontactSubmitHandler(e) {
    e.preventDefault();

    const form = $(e.currentTarget).closest('form')[0];
    const ccData = this.extractCcData(form);
    const nextUrl = urlToAbsolute($('#checkout-bancontact-container').data("checkout-next-url"));
    const failUrl = urlToAbsolute($('#checkout-bancontact-container').data("checkout-fail-url"));

    const bancontactIntent = await this.apiClient.bancontactStripeIntent({
      ccData,
      nextUrl,
      failUrl
    });

    console.log(ccData);
    console.log(bancontactIntent);

    const confirmBancontactParams = {
      payment_method: {
        billing_details: {
          email: ccData.email,
          name: `${ccData.billing.first_name} ${ccData.billing.last_name}`,
        },
      },
      return_url: bancontactIntent.return_url,
    };

    console.log(confirmBancontactParams);

    this.stripe.confirmBancontactPayment(
      bancontactIntent.client_secret,
      confirmBancontactParams
    );


    console.log(e);
  }


  async initStripeIdeal() {
    //stripe-ideal
    if (document.getElementById('checkout-ideal-container') === null) {
      return;
    }

    logWithOffset("Initializing Stripe iDeal");
    await this.initStripeCommon();

    this.idealBankEle = this.stripeElements.create('idealBank', {});
    this.idealBankEle.mount('#checkout-ideal-container');

    this.idealBankEle.on("change", (e) => {
      this.idealBankChoice = e.value;
    })
  }




  async idealSubmitHandler(e) {
    e.preventDefault();

    if (!this.idealBankChoice) {
      alert("Please choose your bank to continue checkout");
      return;
    }

    const form = $(e.currentTarget).closest('form')[0];
    const ccData = this.extractCcData(form);
    const nextUrl = urlToAbsolute($('#checkout-ideal-container').data("checkout-next-url"));
    const failUrl = urlToAbsolute($('#checkout-ideal-container').data("checkout-fail-url"));

    const idealIntent = await this.apiClient.idealStripeIntent({
      ccData,
      nextUrl,
      failUrl
    });

    console.log(ccData);
    console.log(idealIntent);

    const confirmIdealParams = {
      payment_method: {
        ideal: this.idealBankEle,
        billing_details: {
          email: ccData.email,
          name: `${ccData.billing.first_name} ${ccData.billing.last_name}`,
        },
      },
      return_url: idealIntent.return_url,
    };

    console.log(confirmIdealParams);

    this.stripe.confirmIdealPayment(
      idealIntent.client_secret,
      confirmIdealParams
    );


    console.log(e);
  }

  async initStripeWallet() {
    if (document.getElementById('stripe-wallet-button') === null) {
      return;
    }

    let intent = null;

    await this.initStripeCommon();

    const walletData = await checkout.apiClient.walletRequestObject();

    if (!walletData || !walletData.reqObj) {
      return;
    }

    let paymentRequest = null;

    try {
      paymentRequest = this.stripe.paymentRequest(walletData.reqObj);
    } catch(err) {
      logWithOffset(`Unable to initialize stripe payment request: ${err}`);
      return;
    }


    const prButton = this.stripeElements.create('paymentRequestButton', {
      paymentRequest: paymentRequest,
    });

    paymentRequest.canMakePayment().then(function(result) {
      if (result) {
        prButton.mount('#stripe-wallet-button');
      } else {
        document.getElementById('stripe-wallet-button').style.display = 'none';
      }
    });


    paymentRequest.on('shippingaddresschange',  async (ev) => {
      try {
        const response = await this.apiClient.walletShipping({ shippingAddress: ev.shippingAddress });
        console.log("Updating from response");
        ev.updateWith({
          status: 'success',
          displayItems: response.displayItems,
          shippingOptions: response.shippingOptions,
          total: response.total
        });
      } catch(err) {
        console.log("ERR!");
        console.log(err);
        ev.updateWith({status: 'invalid_shipping_address'});
      }
    });

    paymentRequest.on('paymentmethod', async (ev) => {
      intent = await this.apiClient.walletStripeIntent();
      console.log("Intent");
      console.log(intent);
      // Confirm the PaymentIntent without handling potential next actions (yet).
      this.stripe.confirmCardPayment(
        intent.client_secret,
        {payment_method: ev.paymentMethod.id},
        {handleActions: false}
      ).then(async (confirmResult) => {
        if (confirmResult.error) {
          // Report to the browser that the payment failed, prompting it to
          // re-show the payment interface, or show an error message and close
          // the payment interface.
          ev.complete('fail');
        } else {
          // Report to the browser that the confirmation was successful, prompting
          // it to close the browser payment method collection interface.
          ev.complete('success');
          // Check if the PaymentIntent requires any actions and if so let Stripe.js
          // handle the flow. If using an API version older than "2019-02-11" instead
          // instead check for: `paymentIntent.status === "requires_source_action"`.
          if (confirmResult.paymentIntent.status === "requires_action") {
            // Let Stripe.js handle the rest of the payment flow.
            this.stripe.confirmCardPayment(intent.client_secret).then(async (result) => {
              if (result.error) {
                console.log("FAIL");
              } else {
                await this.completeStripeWallet(ev, result);
              }
            });
          } else {
            await this.completeStripeWallet(ev, confirmResult);

          }
        }
      });
    });

    logWithOffset("Stripe Wallet Initialized");


  }

  async fireReadyCallbacks() {
    logWithOffset("Firing Cart Ready Callbacks");
    if (window.checkoutReadyCallbacks && window.checkoutReadyCallbacks.length) {
      for (let i = 0; i < window.checkoutReadyCallbacks.length; i++) {
        window.checkoutReadyCallbacks[i]();
      }

      window.checkoutReadyCallbacks.push = async (fn) => {
        await fn();
      }

    }
    this.ready = true;
  }

  setupNavigateNextUrl() {
    addHandlerBySelector(".checkout-navigate-next-url", "click", ()=> {
      window.location = this.getNextUrl();
    });
  }

  // Live valid/invalid coloring for the plain #exp_date input. Unlike the number/cvv
  // fields, this one isn't inside Spreedly's cross-origin iframe, so it's styled directly
  // instead of through setStyle()'s postMessage — but the decision logic mirrors theirs:
  // green the moment the date is valid, red only once the shopper has left the field at
  // least once with something invalid still in it, neutral otherwise. Reuses the same
  // validationColors from SPREEDLY_CONFIG so all three fields stay visually consistent.
  paintExpDateField(target) {
    const colors = this.spreedlyValidationColors || { valid: '#2e7d32', invalid: '#c62828' };
    const value = target.value.trim();
    const parsed = value ? this.parseExpDate(value) : null;
    const valid = !!parsed && !this.isExpDateOutOfRange(parsed);

    if (valid) {
      target.style.color = colors.valid;
    } else if (this.expDateTouched && value.length > 0) {
      target.style.color = colors.invalid;
    } else {
      target.style.color = '';
    }
  }

  // Auto-inserts the "MM / YY" slash as digits are typed into the merged expiration field.
  // While focused, the year is left exactly as typed — up to a full 4-digit year ("02/2028"
  // stays "02 / 2028" while you're still in the field). Trimming to 2 digits happens only on
  // blur, per the client's own spec: type the full year, trim on losing focus, and leave an
  // already-2-digit value alone rather than re-rendering it.
  setupExpDateAutoFormat() {
    addHandlerBySelector("#exp_date", "input", (e) => {
      let digits = e.target.value.replace(/\D/g, '').slice(0, 6);

      // A leading digit above 1 can only be a single-digit month, so pad it (3 -> 03) and let
      // the shopper go straight to the year. 0 and 1 stay as typed — they're still ambiguous
      // (01, 10, 11, 12), and padding them would make "1" for October unreachable.
      if (digits.length === 1 && Number(digits) > 1) {
        digits = '0' + digits;
      }

      const month = digits.slice(0, 2);
      const year = digits.slice(2);

      e.target.value = year.length > 0 ? `${month} / ${year}` : month;
      this.paintExpDateField(e.target);
    });

    // addHandlerBySelector delegates off document-level bubbling — 'blur' doesn't bubble
    // (see utils.js), so 'focusout' is the event that actually fires here. This is also
    // where the year actually collapses to its last 2 digits — typing itself never trims.
    addHandlerBySelector("#exp_date", "focusout", (e) => {
      this.expDateTouched = true;

      const digits = e.target.value.replace(/\D/g, '').slice(0, 6);
      const month = digits.slice(0, 2);
      const year = digits.slice(2).slice(-2);
      const trimmed = year.length > 0 ? `${month} / ${year}` : month;

      // Idempotent: a value already in MM / YY form is left exactly alone, not re-rendered.
      if (e.target.value !== trimmed) {
        e.target.value = trimmed;
      }

      this.paintExpDateField(e.target);
    });
  }

  async init() {
    const pricingPromise = this.loadPricing();
    await setupTranslations(this.settings.translationsUrl);
    setupTimers(this.apiClient.sessionId);
    if (this.settings.forceVariantId !== null) {
      logWithOffset(`Forcing Variant ${this.settings.forceVariantId}`);
    }
    await this.loadCart(); // This now loads meta..

    // If the cart already has a facebookPixelId set, use that instead.
    if (parseFloat(this.cart.facebookPixelId) > 0) {
      this.settings.facebookPixelId = this.cart.facebookPixelId;
    }

    populateFields(this.settings);
    this.setupCouponField();
    this.setupRemoveVariantButtons();
    this.setupUpsellGrid();
    this.setupNavigateNextUrl();
    this.setupExpDateAutoFormat();

    const checkoutArgs = {
        shippingZone: this.cart.shippingZone,
        paypalSubmitHandler: this.paypalSubmitHandler.bind(this),
        changeCountryHandler: this.changeCountryHandler.bind(this),
        creditCardFormHandler: this.creditCardFormHandler.bind(this),
        comboHandler: this.comboHandler.bind(this)
    }
    await Promise.all([
      setupEvents({ apiClient: this.apiClient, ...this.settings }),
      this.initStripe(),
      this.initBraintree(),
        this.initSpreedly(),
    ]);

    // cant promise all this one along with initStripe....
    await this.initStripeWallet();
    await this.initStripeIdeal();
    await this.initStripeBancontact();

    this.afterpayHandler = new AfterpayLocal({ apiClient: this.apiClient, settings: this.settings, cart: this.cart, doCharge: this.doCharge.bind(this) });
    this.klarnaHandler = new KlarnaLocal({ initialCart: this.cart, apiClient: this.apiClient });
    setupCheckoutForm(checkoutArgs);
    this.drawCart();
    this.setCurrentVariant();
    this.setupSelectVariantHandler();
    this.setupAddonButtons();
    this.setupUpsellListeners();
    this.setupEmailListener();
    this.setupReceiptPage();
    this.setupQuantitySelects();
    this.setupQuantityButtons();
    this.setupPaypalConfirm();
    await pricingPromise;
    window.RTC = new RTC(this); // expose API.
    this.fireReadyCallbacks();

    setTimeout(async () => {
      await this.sendPageViewEvent();
      testMode.call(this,this);
      this.firePixels();
    }, 50);

    setTimeout(async () => {
      const fbp = Cookies.get("_fbp");
      const fbc = Cookies.get("_fbc");

      const facebookParams = {};

      if (typeof(fbp) === 'string' && fbp.length > 0) {
        facebookParams["fbp"] = fbp;
      }
      if (typeof(fbc) === 'string' && fbc.length > 0) {
        facebookParams["fbc"] = fbc;
      }

      if (Object.keys(facebookParams).length > 0) {
        await checkout.apiClient.saveValues(facebookParams);
      }

    }, 5000);

  }

  async setupEmailListener() {
    $("[name='email']").on("blur", (e) => { this.onEmailBlur(e) });
  }

  async fetchStripeIntent() {
    this.settings.stripeIntent = await this.apiClient.setupStripeIntent();
  }

  extractCcData(form) {
    const ccData = {
      accepts_marketing: false,
      accepts_attentive: false,
      accepts_postscript: false,
      shipping: {},
      billing: {}
    };

    const formElements = form.elements;

    const extractFieldName = (name) => {
      const arr = name.split("_");
      arr.shift();
      return arr.join("_");
    };

    for (let i = 0; i < formElements.length; i++) {
      const ele = formElements[i];
      if (ele.name ==="billing_use_shipping") {
        if (ele.checked) {
          ccData['billing_use_shipping'] = ele.value === 'true';
        }
      }
      if (ele.name.startsWith("shipping")) {
        ccData.shipping[extractFieldName(ele.name)] = ele.value;
      } else if (ele.name.startsWith("billing")) {
        ccData.billing[extractFieldName(ele.name)] = ele.value;
      } else if (ele.name.startsWith("accepts_marketing")) {
        ccData.accepts_marketing = ele.checked;
      } else if (ele.name.startsWith("debug_gateway")) {
        ccData.debug_gateway = ele.value;
      } else if (ele.name.startsWith("accepts_attentive")) {
        ccData.accepts_attentive = ele.checked;
      } else if (ele.name.startsWith("accepts_postscript")) {
        ccData.accepts_postscript = ele.checked;
      } else {
        if (ele.name !== '') {
          ccData[ele.name] = ele.value;
        }
      }
    }

    if (typeof(ccData.cc_number) === 'string') {
      ccData.cc_number = ccData.cc_number.replace(/[^0-9]/g, '');
    }
    if (typeof(ccData.cc_cvv) === 'string') {
      ccData.cc_cvv = ccData.cc_cvv.replace(/[^0-9]/g, '');
    }

    // Nov 26, 2025
    // Removing sensitive CHD for easier PCI Compliance
    if (ccData.cc_number !== undefined) {
      ccData.cc_number = '';
    }
    if (ccData.cc_cvv !== undefined) {
      ccData.cc_cvv = '';
    }
    if (ccData.cc_exp_month !== undefined) {
      ccData.cc_exp_month = '';
    }
    if (ccData.cc_exp_year !== undefined) {
      ccData.cc_exp_year = '';
    }
    // END removing sensitive CHD


    if (ccData.billing_use_shipping) {
      ccData.billing = Object.assign({}, ccData.shipping);
    }

    return ccData;



  }

  applyPricingData() {
    if (!this.cart || !this.pricingData) {
      return;
    }
    if (!this.appliedPricingData) {
      this.appliedPricingData = true;
    } else {
      return;
    }
    const map = {
      ".checkout-price": "price",
      ".checkout-compare-price": "compareAtPrice",
      ".checkout-product-title": "productTitle",
      ".checkout-variant-title": "variantTitle",
      ".checkout-compare-price-savings": "compareSavings",
      ".checkout-compare-price-savings-pct": "compareSavingsPct",
    }

    for (let [klass,field] of Object.entries(map)) {
      [...document.querySelectorAll(klass)].forEach(ele => {
          const variantId = ele.dataset.variantId;
          if (this.pricingData[variantId] && this.pricingData[variantId][field]) {

            let val = this.pricingData[variantId][field];
            if (field === "price" || field === "compareAtPrice" || field === "compareSavings") {
               val = this.pricingData[variantId].presentmentPrices[this.cart.cartCurrency][field];
               const divideBy = parseFloat(ele.dataset.divideBy || "1");
               if (divideBy <= 0) {
                 logWithOffset(`WARNING: ${klass} for ${variantId} has a divide-by <= 0, ignoring`);
               } else {
                 val = val / divideBy;
               }
               val = this.currencyFormatter(parseFloat(val));
            }
            ele.innerHTML = val;

          }
      });
    }

    [...document.querySelectorAll('.checkout-variant-image')].forEach(ele => {
        const variantId = ele.dataset.variantId;
        const field = "image";
        if (this.pricingData[variantId] && this.pricingData[variantId][field]) {
          const img = document.createElement("img");
          img.src = this.pricingData[variantId][field];
          ele.appendChild(img);
        }
    });


    [...document.querySelectorAll('.checkout-full-title')].forEach(ele => {
        const variantId = ele.dataset.variantId;
        if (this.pricingData[variantId]) {
          if (this.pricingData[variantId]["productTitle"] && this.pricingData[variantId]["variantTitle"]) {
              const fullTitle = this.pricingData[variantId]["productTitle"] + " " + this.pricingData[variantId]["variantTitle"];
              ele.innerHTML = fullTitle;
          }
        }
    });


    const stockSelector = `.checkout-track-stock${this.settings.trackStockGlobal ? ", [data-variant-id]" : ""}`;

    [...document.querySelectorAll(stockSelector)].forEach(ele => {
        const variantId = ele.dataset.variantId;
        if (this.pricingData[variantId]) {
          const newClass = this.pricingData[variantId]["inStock"] === true ? "checkout-in-stock" : "checkout-out-of-stock";
          ele.classList.add(newClass);
          if (!this.pricingData[variantId]["inStock"] && (ele.tagName === "BUTTON" || ele.tagName === "SELECT" || ele.tagName === "OPTION")) {
            ele.disabled = true;
          }
        }
    });




  }

  // this probally shouldnt be a hard coded file name
  // but its alot faster this way.
  async loadPricing() {
    try {
      const cdnUrl = checkout.settings.apiEndpoint.replace(/^api\./, 'cdn.');
      const raw = await fetch(`https://${cdnUrl}/cafcb58f5f7280959b1327dc8606de30c450e4e1213dbae22afb3004be13f498.json`);
      this.pricingData = Object.freeze(await raw.json());
      this.applyPricingData();
    } catch(err) {
      console.log(err);
    }
  }

  isCheckoutPage() {
    return $('form.checkout-paypal-form, form.checkout-credit-card-form, form.checkout-credit-card-form, form.checkout-combo-form').length  > 0;
  }

  setupPaypalConfirm() {
    $(document).on("click", ".checkout-paypal-confirm", async () => {
      await this.apiClient.confirmPaypal();
      window.location = this.cart.nextUrl; // This is the correct URL as we set it before we directed to paypal initially.
    });
  }

  async sendPageViewEvent() {
    const now = this.normalizedTimestamp();
    const hshKey = `page_view:${this.settings.sessionId}:${now}:${window.location.href}`;
    const eventId = await digestMessage(hshKey);

    const e = { eventType: "page_view",
                url: window.location.href,
                pageTitle: document.title,
                referrer: document.referrer,
                eventId,
                eventSourceUrl: window.location.href,
                createdAt: now,
                isCheckoutPage: this.isCheckoutPage(),
                ...this.eventsCommon(),
              };

    if (typeof(this.settings.landingPageName) === 'string' && this.settings.landingPageName.length > 0) {
      e.pageType = "lander";
    }

    if (typeof(this.settings.upsellPageName) === 'string' && this.settings.upsellPageName.length > 0) {
      e.pageType = "upsell";
      e.upsellPageName = this.settings.upsellPageName;
    }

    if (typeof(this.settings.advertorialPageName) === 'string' && this.settings.advertorialPageName.length > 0) {
      e.pageType = "advertorial";
      e.advertorialPageName = this.settings.advertorialPageName;
    }

    return this.firePixel(e);
  }

  async sendCheckoutStarted(email) {

    const hshKey = `${this.settings.sessionId}:checkout_started`;
    const eventId = await digestMessage(hshKey);
    const e = { eventType: "checkout_started",
                email: email,
                eventId,
                currency: "USD",
                value: this.cart.localCart.subTotal, // Always use localCart when making stats.
                eventSourceUrl: window.location.href,
                createdAt: this.normalizedTimestamp(),
                ...this.eventsCommon()
    };
    return this.firePixel(e);
  }

  async onEmailBlur(e) {
    const validateEmail = (em) => {
        // eslint-disable-next-line no-useless-escape
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(em).toLowerCase());
    }
    const email = $(e.currentTarget).val();
    if (validateEmail(email)) {
      return this.sendCheckoutStarted(email.toLowerCase());
    }
  }

  async stripeCreditCardFormHandler(form) {
    if (this.stripeLock) {
      return;
    }

    this.stripeLock = true;
    const ccData = this.extractCcData(form);
    const billingDetails = {
      email: ccData.email,
      name: `${ccData.billing.first_name} ${ccData.billing.last_name}`,
      phone: ccData.billing.phone,
      address: {
        city: ccData.billing.city,
        country: ccData.billing.country,
        state: ccData.billing.state,
        postal_code: ccData.billing.postal_code,
        line1: ccData.billing.address1,
        line2: ccData.billing.address2
      },
    }

    if (!billingDetails.phone || billingDetails.phone === "") {
      delete billingDetails["phone"];
    }

    await this.fetchStripeIntent();

    const result = await this.stripe.confirmCardSetup(this.settings.stripeIntent.client_secret, {
      payment_method: {
        billing_details: billingDetails,
        card: this.cardNumberElement
      },
    });

    if (result.error) {
      if (result.error.message) {
        alert(result.error.message);
      }
      triggerCheckoutFailedEvent();
      this.stripeLock = false;
    } else {

      let chargeResult = null;
      try {
        chargeResult = await this.apiClient.charge({
          ...ccData,
          stripe_intent: result.setupIntent
        });
      } catch(err) {
        alert(i18next.t("cart.genericProcessingError"));
        triggerCheckoutFailedEvent();
        this.stripeLock = false;
        return;
      }
      if (!chargeResult || "error" in result) {
        alert(result.error);
        triggerCheckoutFailedEvent();
        this.stripeLock = false;
      } else {
        window.location = this.getNextUrl();
      }
    }

  }

  getNextUrl() {
    return urlToAbsolute(this.nextUrlFn ? this.nextUrlFn(this.cart) : this.settings.nextUrl);
  }

  setNextUrlFn(fn) {
    this.nextUrlFn = fn;
  }



  async validateCcFormAddress(addr) {
    try {
      const result = await this.apiClient.validateAddress({address: {
        address1: addr.address1,
        address2: addr.address2,
        city: addr.city,
        province: addr.state,
        zip: addr.postal_code
      }});

      if (result.zip) {
        result.postal_code = result.zip;
        delete result["zip"];
      }

      if (result.province) {
        result.state = result.province;
        delete result["province"];
      }

      return result;
    } catch (error) {
      console.log(error);
      return null;
    }

  }

  addressAlert(addr) {
    let result = `${addr.address1}`;

    if (addr.address2 && addr.address2.length > 0) {
      result += `\n${addr.address2}`;
    }

    result += `\n${addr.city}, ${addr.state} ${addr.postal_code}`;

    return result;
  }
    
  async spreedlyCreditCardFormHandler(e) {
    const form = $(e.currentTarget).closest("form")[0];

    // If we already have a spreedlyToken, it means we're coming back from the paymentMethod callback
    // So we can safely proceed to the normal handler
    const existingToken = form.querySelector('input[name="spreedlyToken"]');
    if (existingToken && existingToken.value) {
      // Only the tokenization callback's own authorized continuation may proceed here. A plain
      // re-click (impatient double-click, or any click landing after a prior charge for this
      // token already started/finished) also finds the token already on the form; without this
      // check it would force the lock open and fire a brand-new purchase call with the same
      // token underneath an in-flight charge - a real duplicate purchase submission, reproduced
      // live on burnerdomain: two purchase calls, same cart, same token, from one click then
      // click-again.
      if (!this._spreedlyHandoff) {
        console.log('Spreedly token already present but this is not the tokenization handoff — ignoring resubmit click');
        return;
      }
      this._spreedlyHandoff = false;
      console.log('Spreedly token already present — proceeding to charge');
      this.ccLock = false;
      return this.handleNonStripeCreditCard(form);
    }

    // First time submission → prevent default and tokenize
    e.preventDefault();

    if (this.ccLock) return;
    this.ccLock = true;

    // Basic validation
    if (!this.validateSpreedlyForm(form)) {
      this.ccLock = false;
      return;
    }

    if (!window.spreedlyInstance) {
      console.error("Spreedly instance not found");
      this.ccLock = false;
      return;
    }

    // Determine billing vs shipping address
    const useDifferentBilling = form.querySelector('input[name="billing_use_shipping"][value="false"]')?.checked === true;

    const getValue = (id) => form.querySelector(`#${id}`)?.value?.trim() || '';

    console.log('Starting Spreedly tokenization with address:', useDifferentBilling ? 'billing' : 'shipping');

    // validateSpreedlyForm already rejected an unparseable date, but that guarantee lives in
    // another method — don't let a future change there turn into a TypeError mid-tokenization.
    const expDate = this.parseExpDate(getValue('exp_date'));
    if (!expDate) {
      console.error('Expiration date failed to parse after validation passed');
      this.ccLock = false;
      return;
    }

    window.spreedlyInstance.tokenizeCreditCard({
      first_name: useDifferentBilling ? getValue('billing_first_name') : getValue('shipping_first_name'),
      last_name:  useDifferentBilling ? getValue('billing_last_name')  : getValue('shipping_last_name'),
      month: expDate.month,
      year:  '20' + expDate.year,
      address1: useDifferentBilling ? getValue('billing_address_1') : getValue('shipping_address_1'),
      address2: useDifferentBilling ? getValue('billing_address_2') : getValue('shipping_address_2'),
      city:     useDifferentBilling ? getValue('billing_city')     : getValue('shipping_city'),
      state:    useDifferentBilling ? getValue('billing_state')    : getValue('shipping_state'),
      zip:      useDifferentBilling ? getValue('billing_postal_code') : getValue('shipping_postal_code'),
      country:  useDifferentBilling ? getValue('billing_country')  : getValue('shipping_country'),
      phone_number: useDifferentBilling ? getValue('billing_phone') : getValue('shipping_phone'),
      email: getValue('email'),
      retained: true   // vault the card at tokenization — a stored-credential (CIT) charge needs a retained method, not a cached one
    });
  }
    
  // Parses "MM/YY", "MM / YY", "MMYY", or a 4-digit-year form ("MM/YYYY", "MMYYYY") into
  // { month: 'MM', year: 'YY' }, or null if invalid. The 6-digit case has to be handled here
  // too, not just in the formatter, since a value set programmatically (autofill, restored
  // form state) can reach validation without our input handler ever having normalized it.
  parseExpDate(raw) {
    const digits = (raw || '').replace(/\D/g, '');
    if (digits.length !== 4 && digits.length !== 6) return null;

    const month = digits.slice(0, 2);
    const year = digits.slice(-2);
    if (Number(month) < 1 || Number(month) > 12) return null;

    return { month, year };
  }

  // A card is good through the last day of its expiration month, so only a strictly earlier
  // month counts as expired. Deliberately kept out of parseExpDate, which stays purely
  // structural — this is a business rule and it reads the (shopper-controlled) local clock,
  // so it's a courtesy check to catch typos early; the gateway remains the real authority.
  isExpDateExpired(expDate) {
    const now = new Date();
    const expYear = 2000 + Number(expDate.year);
    const expMonth = Number(expDate.month);

    return expYear < now.getFullYear() ||
      (expYear === now.getFullYear() && expMonth < now.getMonth() + 1);
  }

  // No card is issued this far out — a ceiling the client set explicitly ("99.9% of cards
  // are within 10 years, so 20 must be enough"). Kept as its own check, separate from
  // isExpDateExpired, so a too-far-future rejection stays distinguishable from an expired
  // one if this ever needs its own message.
  isExpDateTooFarInFuture(expDate) {
    const now = new Date();
    const expYear = 2000 + Number(expDate.year);
    const expMonth = Number(expDate.month);
    const maxYear = now.getFullYear() + 20;

    return expYear > maxYear ||
      (expYear === maxYear && expMonth > now.getMonth() + 1);
  }

  isExpDateOutOfRange(expDate) {
    return this.isExpDateExpired(expDate) || this.isExpDateTooFarInFuture(expDate);
  }

  validateSpreedlyForm(form) {
    let isValid = true;

    // Clear old validation styles
    form.querySelectorAll('.checkout-invalid-field').forEach(el => {
      el.classList.remove('checkout-invalid-field');
    });

    const requiredFields = [
      'email', 'shipping_first_name', 'shipping_last_name',
      'shipping_address_1', 'shipping_city', 'shipping_state',
      'shipping_postal_code', 'shipping_country',
      'exp_date'
    ];

    requiredFields.forEach(id => {
      const field = form.querySelector(`#${id}`);
      if (!field || !field.value.trim()) {
        isValid = false;
        const group = field ? field.closest('.form-group') : null;
        if (group) group.classList.add('checkout-invalid-field');
      }
    });

    // Basic email check
    const emailField = form.querySelector('#email');
    if (emailField && !emailField.value.includes('@')) {
      isValid = false;
      const group = emailField.closest('.form-group');
      if (group) group.classList.add('checkout-invalid-field');
    }

    // Expiration date must parse into a valid MM/YY, not already be in the past, and not
    // be implausibly far in the future
    const expDateField = form.querySelector('#exp_date');
    const parsedExpDate = expDateField ? this.parseExpDate(expDateField.value) : null;
    if (expDateField && expDateField.value.trim() &&
        (!parsedExpDate || this.isExpDateOutOfRange(parsedExpDate))) {
      isValid = false;
      const group = expDateField.closest('.form-group');
      if (group) group.classList.add('checkout-invalid-field');
    }

    if (!isValid) {
      const firstError = form.querySelector('.checkout-invalid-field');
      if (firstError) firstError.scrollIntoView({ behavior: 'smooth' });
    }

    return isValid;
  }

  async handleNonStripeCreditCard(form) {
    if (this.ccLock) {
      return;
    }
    this.ccLock = true;


    const ccData = this.extractCcData(form);

    if (this.settings.userAddressCorrect === "true" && ccData.shipping.country === 'US' && this.apiClient.validateAddress !== undefined) {
      const cleanShipping = await this.validateCcFormAddress(ccData.shipping);
      if (cleanShipping) {
        if (Object.keys(cleanShipping).length === 0) {

          let errorMsg = `The USPS was unable to find this address:\n\n`;
          errorMsg += this.addressAlert(ccData.shipping);
          errorMsg += `\n\nClick Ok to use Anyways.`;

          if (!window.confirm(errorMsg)) {
            this.ccLock = false;
            return false;
          }
        } else {
          const newShippingAddress = Object.assign({}, ccData.shipping, cleanShipping);

          const oldShippingAddress = Object.assign({}, ccData.shipping);

          const lDist = distance(this.addressAlert(oldShippingAddress).toLowerCase(), this.addressAlert(newShippingAddress).toLowerCase());

          const autoAccept = (ccData.shipping.postal_code === newShippingAddress.postal_code && ccData.shipping.state === newShippingAddress.state && lDist < 3);


          let changeAlert = `The USPS has suggested this address\n\n`;
          changeAlert += this.addressAlert(newShippingAddress);
          changeAlert += `\n\nClick Ok to Accept.`;

          if (autoAccept || window.confirm(changeAlert)) {
            ccData.shipping = Object.assign({}, newShippingAddress);
            if (ccData.billing_use_shipping) {
              ccData.billing = Object.assign({}, ccData.shipping);
            }
          }
        }
      }
    }

    const isSpreedly = ($(form).find('input[name="spreedlyToken"]').length > 0);
    if (isSpreedly) {
      try {
        const tokenField = form.querySelector('input[name="spreedlyToken"]');
        if (tokenField && tokenField.value) {
          ccData.spreedlyToken = tokenField.value;
          console.log('Spreedly token attached to ccData');
        } else {
          throw new Error("Spreedly token missing after tokenization");
        }
      } catch(err) {
        console.error("Spreedly token error:", err);
        this.ccLock = false;
        triggerCheckoutFailedEvent();
        alert(i18next.t("braintree.missingCreditCardFields") || "Missing credit card token");
        return;
      }
    }

    const isBraintree = ($(form).find('#braintree-cc-number').length > 0);

    if (isBraintree) {
      try {
        ccData.braintreeTokenization = await this.braintreeHostedFieldsInstance.tokenize();
      } catch(err) {
        this.ccLock = false;
        triggerCheckoutFailedEvent();
        alert(i18next.t("braintree.missingCreditCardFields"));
        return;
      }

    }
      
    let result = null;

    try {
      result = await this.apiClient.charge(ccData);
    } catch(err) {
      this.ccLock = false;
      alert(i18next.t("cart.genericProcessingError"));
      triggerCheckoutFailedEvent();
    }

    if (!result || "error" in result) {
      this.ccLock = false;
      alert(result.error);
      triggerCheckoutFailedEvent();
    } else {
      window.location = this.getNextUrl();
    }

  }


  async doCharge(data) {

    if (this.ccLock) {
      return;
    }
    this.ccLock = true;
    let result = null;
    try {
      result = await this.apiClient.charge(data);
    } catch(err) {
      this.ccLock = false;
      alert(i18next.t("cart.genericProcessingError"));
      triggerCheckoutFailedEvent();
      return false;
    }

    if (!result || "error" in result) {
      this.ccLock = false;
      alert(result.error);
      triggerCheckoutFailedEvent();
      return false;
    } else {
      return true;
    }
  }

  async klarnaComboHandler(e) {
    console.log(e);
    const form = $(e.currentTarget).closest("form")[0];
    console.log(form);
    const ccData = this.extractCcData(form);
    /*
    {
    "accepts_marketing": true,
    "accepts_attentive": false,
    "accepts_postscript": false,
    "shipping": {
        "first_name": "STEPHEN",
        "last_name": "BLACKSTONE",
        "address1": "12 Hoinski Way",
        "address2": "",
        "city": "Ansonia",
        "state": "CT",
        "postal_code": "06401",
        "country": "US",
        "phone": "2034305559"
    },
    "billing": {
        "first_name": "STEPHEN",
        "last_name": "BLACKSTONE",
        "address1": "12 Hoinski Way",
        "address2": "",
        "city": "Ansonia",
        "state": "CT",
        "postal_code": "06401",
        "country": "US",
        "phone": "2034305559"
    },
    "email": "sblackstone@gmail.com",
    "billing_use_shipping": true,
    "cc_number": "",
    "cc_exp_month": "",
    "cc_exp_year": "",
    "cc_cvv": "",
    "combo_mode": "klarna"
}
*/

    this.klarnaHandler.authorize(ccData);
  }

  async comboHandler(e) {
    const form = $(e.currentTarget).closest("form");
    let currentModel = $(form).find("input[name='combo_mode']:checked").val();

    if (!currentModel) {
      currentModel = $(form).find("input[name='combo_mode']").val();
    }

    e.preventDefault();

    if (currentModel === 'credit') {
      return this.creditCardFormHandler(e);
    }

    if (currentModel === 'klarna') {
      return this.klarnaComboHandler(e);
    }

    if (currentModel === 'paypal') {
      return this.paypalSubmitHandler(e);
    }

    if (currentModel === 'ideal') {
      return this.idealSubmitHandler(e);
    }
    if (currentModel === 'bancontact') {
      return this.bancontactSubmitHandler(e);
    }
  }

  async creditCardFormHandler(e) {
    const form = $(e.currentTarget).closest("form");

    const isStripe = form.find("#stripe-cc-number").length > 0;
    if (isStripe) {
      return this.stripeCreditCardFormHandler(form[0]);
    }

    const isSpreedly = form.find("#spreedly-number").length > 0;
    if (isSpreedly) {
      return this.spreedlyCreditCardFormHandler(e);
    }

    // Braintree and other non-Stripe credit card handlers
    const isCcForm = (form.find('input[name="cc_number"]').length > 0) ||
                     (form.find('#braintree-cc-number').length > 0);
    if (isCcForm) {
      return this.handleNonStripeCreditCard(form[0]);
    }

    throw "Unknown Credit Card";
  }

  normalizedTimestamp() {
    return (+new Date()) + this.clientTimestampDrift;
  }

  async paypalSubmitHandler() {
    const results = await Promise.all([
      this.sendCheckoutStarted(),
      checkout.apiClient.initPaypalFast(this.getNextUrl())
    ]);

    window.location = results[1].redirectUrl;
  }

  async changeCountryHandler(e) {
      const newCart = await this.apiClient.setCountry(e.currentTarget.value);
      this.setCart(newCart);
      this.klarnaHandler.updateCountry(e.currentTarget.value);
  }

  async applyCoupon(couponCode) {
    if (typeof(couponCode) === 'string' && this.currentCouponCode() !== couponCode.toUpperCase()) {
      this.setCart(await this.apiClient.applyCoupon(couponCode));
    }
  }

  async removeCoupon(couponCode) {
    if (this.currentCouponCode()) {
      this.setCart(await this.apiClient.removeCoupon());
    }
  }

  fireCheckoutUpdateCallbacks() {
    window.checkoutUpdateCallbacks.map(x => x(this.cart));
  }
  setCart(newCart) {

    if (newCart) {
      newCart.localCart = new LocalCart(newCart.localCart);
    }
    if (newCart.currencyCart) {
      newCart.currencyCart = new LocalCart(newCart.currencyCart);
    }

    this.cart = Object.freeze(newCart);
    const defaultCurrencyFormatter = new Intl.NumberFormat(this.cart.locale, { style: 'currency', currency: this.cart.cartCurrency }).format;

    this.currencyFormatter = ((value) => {
        return this.currencyFormatterCallback(defaultCurrencyFormatter(value));
    }).bind(this);

    this.applyPricingData();

    window.checkoutData.cart = newCart;

    this.drawCart();
    // Make sure RTC has been defined.
    // We explictly call checkoutUpdateCallbacks at the end of config...
    if (window.RTC) {
      this.fireCheckoutUpdateCallbacks();
    }

  }

  load_settings() {
    this.settings = {};
    const urlParams = new URLSearchParams(window.location.search);
    this.settings.urlCoupon             = urlParams.get('coupon');
    this.settings.forceVariantId        = urlParams.get('forceVariantId') || $('meta[name="checkout-force-variant-id"]').attr("content") || null;
    this.settings.recoveryCartId        = urlParams.get('recoveryCartId');
    this.settings.resetCookie           = urlParams.get('resetCookie') === "true";
    this.settings.forceCartId           = urlParams.get('forceCartId') || window.checkoutForceId  || "";
    this.settings.forceShippingZone     = urlParams.get('forceShippingZone') || "";
    this.settings.debugForeignCurrency  = urlParams.get('debugForeignCurrency') || "false";
    this.settings.isReceiptPage         = $('meta[name="checkout-receipt-page"]').attr("content") === "true";
    this.settings.apiEndpoint           = $('meta[name="checkout-api-endpoint"]').attr("content");
    this.settings.facebookPixelId       = $('meta[name="checkout-facebook-pixel"]').attr("content");
    this.settings.defaultVariantId      = $('meta[name="checkout-default-variant-id"]').attr("content");
    this.settings.defaultAddons         = $('meta[name="checkout-default-addons"]').attr("content") || "";
    this.settings.nextUrl               = $('meta[name="checkout-next-url"]').attr("content");
    this.settings.landingPageName       = $('meta[name="checkout-landing-page-name"]').attr("content") || "";
    this.settings.auxPageName           = $('meta[name="checkout-aux-page-name"]').attr("content") || "";
    this.settings.upsellPageName        = $('meta[name="checkout-upsell-page-name"]').attr("content") || "";
    this.settings.funnelName            = $('meta[name="checkout-funnel-name"]').attr("content") || "";
    this.settings.checkoutPageName      = $('meta[name="checkout-page-name"]').attr("content") || "";
    this.settings.orderTag              = $('meta[name="checkout-order-tag"]').attr("content") || "";
    this.settings.advertorialPageName   = $('meta[name="checkout-advertorial-page-name"]').attr("content") || "";
    this.settings.paypalConfirmUrl      = urlToAbsolute($('meta[name="checkout-paypal-confirm-url"]').attr("content")) || "";
    this.settings.trackStockGlobal      = $('meta[name="checkout-track-stock-global"]').attr("content") === "true";
    this.settings.translationsUrl       = $('meta[name="checkout-translations-url"]').attr("content") || "";
    this.settings.spreedlyPublicKey     = $('meta[name="checkout-spreedly-public-key"]').attr("content");

    if (window.__APP_CONFIG__ && window.__APP_CONFIG__.aid && window.__APP_CONFIG__.aid.length) {
      this.settings.outsmartlyId = window.__APP_CONFIG__.aid;
    }


    this.settings.checkoutPage        = window.location.href;
    //console.log(this.settings);

    const origParams = {};

    for (const [key,value] of urlParams.entries()) {
      origParams[key] = value;
    }

    this.settings.checkoutPageParams  = JSON.stringify(origParams);
  }

  updateSubtotal() {

    if (this.cart && this.cart.currencyCart) {
      let lineItemVal = parseFloat(this.cart.currencyCart.lineItemTotal);
      let subtotal    = parseFloat(this.cart.currencyCart.subTotal);
      let total       = parseFloat(this.cart.currencyCart.total);
      let discount    = parseFloat(this.cart.currencyCart.discountTotal);

      $('.checkout-total-value').html(this.currencyFormatter(total));
      $('.checkout-subtotal-value').html(this.currencyFormatter(subtotal));
      $('.checkout-subtotal-with-discounts-value').html(this.currencyFormatter(subtotal - discount));
      $('.checkout-discount-value').html(this.currencyFormatter(discount));
      $('.checkout-total-line-item-value').html(this.currencyFormatter(lineItemVal));

      const ts = this.cart.currencyCart.totalSavings();
      if (ts.totalSavings) {
        $(".checkout-total-savings-value").html(this.currencyFormatter(ts.totalSavings));
      }
      if (ts.totalSavingsPct) {
        $(".checkout-total-savings-pct").html(ts.totalSavingsPct);
      }

      if (ts.compareAtTotal) {
        $(".checkout-total-compare-value").html(this.currencyFormatter(ts.compareAtTotal));
      }

    }
  }

  drawCart() {
    this.updateAddonButtons();
    this.updateVariantQuantityFields();
    this.updateSubtotal();

    if (this.cart.localCart.discountType !== "") {
      $('.checkout-coupon-field').hide();
      $('.checkout-coupon-button').hide();
    } else {
      $('.checkout-coupon-field').show();
      $('.checkout-coupon-button').show();

    }

    for (let i of document.querySelectorAll('.checkout-cart-display')) {
      const showTaxPendingMessage = (i.dataset.showTaxPendingMessage === 'true');
      const showComparePricing    = (i.dataset.showComparePricing    === 'true');
      const showProductImages     = (i.dataset.showProductImages     === 'true');
      const showVatIncluded       = (i.dataset.showVatIncluded       === 'true');
      //const currencySymbol        = i.dataset.currencySymbol || "";
      i.innerHTML = window.rtcDrawCartFn({ currencyCart: this.cart.currencyCart, showTaxPendingMessage, showComparePricing, showProductImages, showVatIncluded, currencyFormatter: this.currencyFormatter, lineItemHtmlFn: this.lineItemHtmlFn });
    }
  }


  async setLineItemHtmlFn(fn) {
    this.lineItemHtmlFn = fn;
    this.drawCart();
  }

  async handleAddCoupon(e) {
    e.preventDefault();
    const couponCode = prompt("Enter Coupon Code");
    if (couponCode) {
      this.setCart(await this.apiClient.applyCoupon(couponCode));
    } else {
      console.log("Coupon cancel");
    }
  }

  async loadCart() {
    const result = await this.apiClient.getCart(this.settings);
    this.settings = Object.assign({}, this.settings, result.meta);
    this.clientTimestampDrift = result.meta.serverNow - (+new Date());
    logWithOffset("Cart Loaded");
    this.setCart(result.cart);
  }

  async setCartLineItems() {
    const result  = await this.apiClient.setCart(this.cart);
    if (!("error" in result)) {
      return this.cart;
    } else {
      return result;
    }
  }

  setCurrentVariant() {
    $('.checkout-selected-variant').removeClass("checkout-selected-variant");
    $(`.checkout-select-variant[data-variant-id="${this.cart.primaryVariantId}"]`).addClass('checkout-selected-variant');
    $(`.checkout-variant-target[data-variant-id="${this.cart.primaryVariantId}"]`).addClass('checkout-selected-variant');
  }

  async setCurrentVariantManual(val) {
    this.currentVariant = val;
    const result  = await this.apiClient.setCurrentVariant(val);
    if (!("error" in result)) {
      this.setCart(result);
      this.setCurrentVariant();
      this.drawCart();
      return this.cart;
    } else {
      return result;
    }
  }

  setupUpsellListeners() {
    let acceptUpsellLock = false;


    $("form.checkout-accept-upsell").on("submit", async (e)=> {
      e.preventDefault();
      if (acceptUpsellLock) {
        return;
      }
      acceptUpsellLock = true;

      console.log(e.currentTarget);

      const data = {
        upsellType: $(e.currentTarget).data("upsell-type"),
        nextUrl: $(e.currentTarget).data("next-url"),
        upsellParam1: $(e.currentTarget).find("[name='upsellParam1']").val(),
        upsellParam2: $(e.currentTarget).find("[name='upsellParam2']").val(),
        upsellPageName: this.settings.upsellPageName,
        upsellUrl: window.location.href,
      };

      console.log(JSON.stringify(data, null, 4));

      await this.apiClient.acceptUpsell(data);

      if (this.nextUrlFn) {
        window.location =  this.nextUrlFn(this.cart);
      } else {
        window.location =  $(e.currentTarget).data("next-url");
      }

      acceptUpsellLock = false;

      return false;

    });

    $('.checkout-debug').on("click", ()=> {
      alert(this.apiClient.sessionId);
    });

    $("div.checkout-accept-upsell, button.checkout-accept-upsell, a.checkout-accept-upsell").on("click", async (e)=> {
      e.preventDefault();
      if (acceptUpsellLock) {
        return;
      }
      acceptUpsellLock = true;

      const data = {
        upsellType: $(e.currentTarget).data("upsell-type"),
        upsellParam1: $(e.currentTarget).data("upsell-param1"),
        upsellParam2: $(e.currentTarget).data("upsell-param2"),
        nextUrl: $(e.currentTarget).data("next-url"),
        upsellPageName: this.settings.upsellPageName,
        upsellUrl: window.location.href,

      }

      await this.apiClient.acceptUpsell(data);

      if (this.nextUrlFn) {
        window.location =  this.nextUrlFn(this.cart);
      } else {
        window.location =  $(e.currentTarget).data("next-url");
      }

      acceptUpsellLock = false;

      return false;
    });

  }


  async acceptUpsellGridData(variantData) {

    const data = {
      upsellType: "add-grid",
      variants: variantData,
      upsellPageName: this.settings.upsellPageName
    };

    return this.apiClient.acceptUpsell(data);

  }


  setupUpsellGrid() {
    let acceptUpsellLock = false;


    const updateCheckoutGridMeta = async () => {


      const eles = [ ...document.querySelectorAll(".checkout-upsell-grid-selector"), ...document.querySelectorAll('.checkout-upsell-quantity-display') ];
      let total = 0.0;
      let compareTotal = 0.0;

      for (let i = 0; i < eles.length; i++) {
        const e = eles[i];
        const variantId = $(e).data("variant-id");
        const qty       = e.tagName === "SELECT" ? parseFloat($(e).val()) : parseFloat($(e).html());
        if (qty > 0) {
          try {
            const vd = this.getVariantData(variantId);
            if (vd && vd.compareAtPrice) {
              compareTotal += parseFloat(vd.compareAtPrice) * qty;
            }
            if (vd && vd.price) {
              total  += parseFloat(vd.price) * qty;
            }
          } catch (err) {
            console.log(err);
            console.log(`Upsell grid could not find pricing for ${variantId}`);
          }
          //data.variants[variantId] = qty;
        }
      }

      $(".checkout-upsell-grid-total").html(this.currencyFormatter(total));
      $(".checkout-upsell-grid-compare-total").html(this.currencyFormatter(compareTotal));

    };

    updateCheckoutGridMeta();

    $(document).on("click", ".checkout-upsell-quantity-increase", async (e) => {
      const variantId = $(e.currentTarget).data("variant-id");
      const increment = parseFloat($(e.currentTarget).data("quantity-increment")) || 1;
      const maxVal    = parseFloat($(e.currentTarget).data("quantity-max")) || 999;
      const valEle    = document.querySelector(`.checkout-upsell-quantity-display[data-variant-id="${variantId}"]`);
      const curQty    = parseFloat(valEle.innerText);
      const newQty    = Math.min(maxVal, curQty+increment);
      if (newQty !== curQty) {
        valEle.innerText = newQty;
        console.log(`increase ${variantId} upto ${maxVal} max, cur=${curQty}, new=${newQty}`);
        updateCheckoutGridMeta();
      }
    });

    $(document).on("click", ".checkout-upsell-quantity-decrease", async (e) => {
      const variantId = $(e.currentTarget).data("variant-id");
      const increment = parseFloat($(e.currentTarget).data("quantity-increment")) || 1;
      const minVal    = parseFloat($(e.currentTarget).data("quantity-min")) || 0;
      const valEle    = document.querySelector(`.checkout-upsell-quantity-display[data-variant-id="${variantId}"]`);
      const curQty    = parseFloat(valEle.innerText);
      const newQty    = Math.max(minVal, curQty-increment);
      if (newQty !== curQty) {
        valEle.innerText = newQty;
        console.log(`increase ${variantId} downto ${minVal} max, cur=${curQty}, new=${newQty}`);
        updateCheckoutGridMeta();
      }
    });


    $(document).on("change", ".checkout-upsell-grid-selector", async (e) => {
      updateCheckoutGridMeta();
    });

    $(document).on("click", ".checkout-submit-upsell-grid", async (e)=> {
      e.preventDefault();

      if (acceptUpsellLock) {
        return;
      }

      acceptUpsellLock = true;

      const parentEle = $(e.currentTarget).parent(".checkout-accept-upsell-grid");
      if (!parentEle) {
        return false;
      }

      const data = {
        upsellType: "add-grid",
        variants: {},
        upsellPageName: this.settings.upsellPageName
      };

      const selects = $(parentEle).find(".checkout-upsell-grid-selector").toArray();

      for (let i = 0; i < selects.length; i++) {
        const s = selects[i];
        const variantId = $(s).data("variant-id");
        const qty       = parseFloat($(s).val());
        if (qty > 0) {
          data.variants[variantId] = qty;
        }
      }

      const displays = $(parentEle).find('.checkout-upsell-quantity-display').toArray();

      for (let i = 0; i < displays.length; i++) {
        const d = displays[i];
        const variantId = $(d).data("variant-id");
        const qty = parseFloat($(d).html());
        if (qty > 0) {
          data.variants[variantId] = qty;
        }
      }

      if (Object.keys(data.variants).length > 0) {
        await this.apiClient.acceptUpsell(data);
        if (this.nextUrlFn) {
          window.location =  this.nextUrlFn(this.cart);
        } else {
          window.location =  $(parentEle).data("next-url");
        }
      }

      acceptUpsellLock = false;

      return false;



    });
  }

  updateVariantQuantityFields() {
    $('.checkout-variant-quantity-selector').val(0);
    $('.checkout-quantity-display').html(0);
    if (this.cart.localCart) {
      //console.log(this.cart.localCart);
      this.cart.localCart.lineItems.forEach((li)=> {
        const numericId = li.variantId;
        $(`.checkout-variant-quantity-selector[data-variant-id="${numericId}"]`).val(li.quantity);
        $(`.checkout-quantity-display[data-variant-id="${numericId}"]`).html(li.quantity);
      });
    }
  }

  setupQuantitySelects() {
    $(document).on("change", '.checkout-variant-quantity-selector', async () => {
      const data = {};

      const eles = $('.checkout-variant-quantity-selector').toArray();

      for (const ele of eles) {
        const variantId = $(ele).data("variant-id");
        const val = $(ele).val();
        data[variantId] = val;
      }


      this.setCart(await this.apiClient.setVariantQuantities(data));
    });
  }


  getVariantQuantities() {
    const result = {};
    this.cart.localCart.lineItems.map(x => result[x.variantId] = x.quantity);
    return result;
  }

  async setVariantQuantities(data) {
    // check if anything has changed - don't make an unnecessary API call.
    const cur = this.getVariantQuantities();

    let dirty = false;

    for (const [k,v] of Object.entries(data)) {
      if (cur[k] != v) {
        dirty = true;
      }
    }

    if (dirty) {
      this.setCart(await this.apiClient.setVariantQuantities(data));
    }
  }

  setupQuantityButtons() {



    $(document).on("click", ".checkout-quantity-increase", async (e) => {
      const variantId = $(e.currentTarget).data("variant-id");
      const maxVal    = parseFloat($(e.currentTarget).data("quantity-max")) || 999;
      const curQty    = this.cart.localCart.getVariantQuantity(variantId);
      const newQty    = Math.min(maxVal, curQty+1);
      if (newQty !== curQty) {
        this.setCart(await this.apiClient.setVariantQuantities({
          [variantId]: newQty
        }));
        //console.log(`increase ${variantId} upto ${maxVal} max, cur=${curQty}, new=${newQty}`);
      }
    });

    $(document).on("click", ".checkout-quantity-decrease", async (e) => {
      const variantId = $(e.currentTarget).data("variant-id");
      const minVal    = parseFloat($(e.currentTarget).data("quantity-min")) || 0;
      const curQty    = this.cart.localCart.getVariantQuantity(variantId);
      const newQty    = Math.max(minVal, curQty-1);
      if (newQty !== curQty) {
        this.setCart(await this.apiClient.setVariantQuantities({
          [variantId]: newQty
        }));
        //console.log(`increase ${variantId} downto ${minVal} min, new=${newQty}`);
      }
    });


  }

  updateAddonButtons() {
    $('.checkout-selected-addon').removeClass("checkout-selected-addon");

    if (this.cart.localCart) {
      //console.log(this.cart.localCart);
      this.cart.localCart.lineItems.forEach((li)=> {
        const numericId = li.variantId;
        $(`.checkout-addon-toggle[data-variant-id="${numericId}"]`).addClass("checkout-selected-addon");
      });
    }
  }

  setupRemoveVariantButtons() {
      $(document).on("click", ".checkout-remove-variant", async (e) => {
        const variantId = $(e.currentTarget).data("variant-id");
        const curQty    = this.cart.localCart.getVariantQuantity(variantId);
        if (curQty != 0) {
          this.setCart(await this.apiClient.setVariantQuantities({ [variantId]: 0 }));
        }
      });
  }

  setupAddonButtons() {

    let addonButtonLock = false;

    $('.checkout-addon-toggle').on("click", async (e)=> {
      if (addonButtonLock) {
        return;
      }
      addonButtonLock = true;
      $(e.currentTarget).toggleClass('checkout-selected-addon');
      const variantId = $(e.currentTarget).data("variant-id");

      this.setCart(await this.apiClient.toggleAddon(variantId));

      this.setCurrentVariant();
      addonButtonLock = false;
    });
  }

  setupSelectVariantHandler() {

    let selectVariantLock = false;
    $('.checkout-select-variant').on("click", async(e)=> {
      if (selectVariantLock) {
        return;
      }
      selectVariantLock = true;

      const variantId = $(e.currentTarget).data("variant-id");
      $('.checkout-selected-variant').removeClass("checkout-selected-variant");

      $(`.checkout-select-variant[data-variant-id=${variantId}]`).addClass('checkout-selected-variant');

      $(`.checkout-variant-target[data-variant-id=${variantId}]`).addClass('checkout-selected-variant');

      this.setCart(await this.apiClient.setCurrentVariant(variantId));
      this.setCurrentVariant();
      selectVariantLock = false;
    });
  }
}

Checkout.addPixel = function(callback) {
  window.checkoutReadyCallbacks = window.checkoutReadyCallbacks || [];
  window.checkoutReadyCallbacks.push(() => {
    window.checkout.addPixel(callback);
  });
};


Checkout.setNextUrlFn = function(callback) {
  console.log("setNextUrlFn");
  window.checkoutReadyCallbacks = window.checkoutReadyCallbacks || [];
  window.checkoutReadyCallbacks.push(() => {
    window.checkout.setNextUrlFn(callback);
  });
};


window.Checkout = Checkout; /* to expose addPixel as static on global */

$(async function() {
  const checkout = new Checkout();
  checkout.init();
});
